module.exports = __webpack_public_path__ + "static/media/instructivom2.20fd3ac5.png";